import { z } from 'zod';

export const uuidSchema = z.string().uuid('Identifiant invalide');

/** Dates métier en AAAA-MM-JJ : un budget raisonne en jours, pas en instants. */
export const isoDateSchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, 'Date attendue au format AAAA-MM-JJ');

/** Montant signé, en centimes. */
export const centsSchema = z
  .number()
  .int('Un montant s’exprime en centimes entiers')
  .finite()
  .min(-1_000_000_000)
  .max(1_000_000_000);

/** Montant saisi par l'utilisateur : toujours positif, le sens vient du type. */
export const positiveCentsSchema = centsSchema.positive('Le montant doit être positif');

export const dayOfMonthSchema = z.number().int().min(1).max(31);

export const labelSchema = z.string().trim().min(1, 'Libellé obligatoire').max(120);
